import type { CSSProperties, FC, ReactNode } from "react";

import { Button } from "@9amhealth/shared";

interface MealInsightActionButtonProps {
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  destructive?: boolean;
}

const MealInsightActionButton: FC<MealInsightActionButtonProps> = ({
  label,
  onClick,
  disabled = false,
  destructive = false
}) => {
  const overrideStyle = {
    "--inner-background": "var(--color-cream, #fffcf3)",
    ...(destructive ? { "--border-size": "1px" } : {})
  } as CSSProperties;

  return (
    <Button
      theme={destructive ? "danger" : "sunrise"}
      outline
      grow
      hideArrow
      isDisabled={disabled}
      onPress={onClick}
      style={overrideStyle}
    >
      {label}
    </Button>
  );
};

export default MealInsightActionButton;
